import AppStoreWidget from './AppStoreWidget';

export default AppStoreWidget;
